import { render, staticRenderFns } from "./DiscernmentLicencePlate.vue?vue&type=template&id=1f03d4a2&scoped=true"
import script from "./DiscernmentLicencePlate.vue?vue&type=script&lang=js"
export * from "./DiscernmentLicencePlate.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentLicencePlate.vue?vue&type=style&index=0&id=1f03d4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03d4a2",
  null
  
)

export default component.exports